module.exports = __webpack_public_path__ + "static/logo2-b37daa69d0008d7cfd105c3f510f7e36.svg";